module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/chicken-2.4e061534.png";